export var BuildingCategory;
(function (BuildingCategory) {
    BuildingCategory[BuildingCategory["Facilities"] = 2] = "Facilities";
    BuildingCategory[BuildingCategory["Decorations"] = 4] = "Decorations";
    BuildingCategory[BuildingCategory["SpecialBuildings"] = 5] = "SpecialBuildings";
    BuildingCategory[BuildingCategory["SpecialDecorations"] = 15] = "SpecialDecorations";
    BuildingCategory[BuildingCategory["Stored"] = 10] = "Stored";
})(BuildingCategory || (BuildingCategory = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/BuildingCategory.ts
// module id = 325
// module chunks = 3